import { forwardRef, ReactElement, useImperativeHandle, useRef, useState } from 'react'
import { Color, Field } from '@mrshmllw/smores-react'

import { ExitSurveyModal } from './components/ExitSurveyModal'
import { RegistrationInput } from './components/RegistrationInput'

import { TrackingFunction } from 'utils'

type RegistrationLookupProps = {
  onRegPlateChange: (regPlate: string) => void
  regPlate: string
  showExitSurveyBtn?: boolean
  track?: TrackingFunction
  isLoading: boolean
  dvlaDataError: boolean
  dvlaErrorMessage: string | ReactElement
  fullWidthSubmit?: boolean
  textColour?: Color
  useAsSubmit?: boolean
  form: string
  buttonVariant?: 'primary' | 'secondary'
  error: boolean
  errorMsg?: string
}

export const RegistrationLookup = forwardRef<{ focus: VoidFunction }, RegistrationLookupProps>(
  (
    {
      onRegPlateChange,
      regPlate,
      showExitSurveyBtn,
      track,
      isLoading,
      dvlaDataError,
      dvlaErrorMessage,
      form,
      textColour = 'liquorice',
      fullWidthSubmit = false,
      useAsSubmit = false,
      buttonVariant = 'primary',
      error,
      errorMsg,
    },
    ref,
  ) => {
    const [showExitModal, setShowExitModal] = useState(false)
    const [hasSubmittedSurvey, setHasSubmittedSurvey] = useState(false)

    const vehicleInputRef = useRef<HTMLInputElement>(null)
    useImperativeHandle(ref, () => ({
      focus: () => vehicleInputRef.current?.focus(),
    }))

    return (
      <>
        <Field error={dvlaDataError} errorMsg={dvlaErrorMessage}>
          <RegistrationInput
            form={form}
            buttonVariant={buttonVariant}
            textColour={textColour}
            setPlateNumber={onRegPlateChange}
            searching={isLoading}
            regPlate={regPlate}
            inputRef={vehicleInputRef}
            setShowExitModal={setShowExitModal}
            showExitSurveyBtn={showExitSurveyBtn}
            fullWidthSubmit={fullWidthSubmit}
            useAsSubmit={useAsSubmit}
            error={error}
            errorMsg={errorMsg}
          />
        </Field>
        {track && (
          <ExitSurveyModal
            showModal={showExitModal}
            handleClick={() => setShowExitModal(false)}
            track={track}
            hasSubmittedSurvey={hasSubmittedSurvey}
            setHasSubmittedSurvey={setHasSubmittedSurvey}
          />
        )}
      </>
    )
  },
)
